<nav>
  <a class="nav-logo" [routerLink]="['/']">
    <img src="logo.png" alt="CradleResident Logo" width="36" height="36">
    <span>CradleResident</span>
  </a>
  <ul class="nav-links">
    <li><a [routerLink]="['/']" [fragment]="'features'">Características</a></li>
    <li><a [routerLink]="['/features']" routerLinkActive="active">Funciones</a></li>
    <li><a [routerLink]="['/']" [fragment]="'how'">Cómo funciona</a></li>
    <li><a [routerLink]="['/']" [fragment]="'pricing'">Planes</a></li>
    <li><a [routerLink]="['/']" [fragment]="'why'">Por qué</a></li>
  </ul>
  <a class="nav-cta" [routerLink]="['/']" [fragment]="'contact'">Solicitar demo</a>
</nav>
